// extracted by mini-css-extract-plugin
export default {"text":"views-ContentPage-components-themes-PP-textAdLink__text--s2Qke","link":"views-ContentPage-components-themes-PP-textAdLink__link--E81GO"};